/**
 * Dev/Staging app configuration
 */
import { DeviceFamilies, StripePricingIdsTest } from "@Enums";
import Regions from "./regions";

export default {
  // Firebase App Config
  apiKey: "AIzaSyB_H1_Btnc2aTBCjpQ4cHsjzrSPdkcE6T4",
  authDomain: "byb-dev-env.firebaseapp.com",
  databaseURL: "https://byb-dev-env.firebaseio.com",
  projectId: "byb-dev-env",
  storageBucket: "byb-dev-env.appspot.com",
  messagingSenderId: "514510958610",
  measurementId: "G-SF1L6GXP0W",
  appId: "1:514510958610:web:00361da616a1f1710628cb",
  // Region is used by the Frontend app to point to correct zone where Backend functions & Hosting is deployed (Important to remain in EU for data privacy)
  region: Regions.EUROPE_WEST_1,
  // Stripe Config
  stripeApiKey: "pk_test_51HIBL7Jxfuw0gUiinJX8ckDnjm7kNOIezZUXljK7WQSml1onxGlY8iZjbcON7BfUHlbuAjD3sNt8g02NM0HiHyGU00Cvbtqitz",
  stripePricingIds: StripePricingIdsTest,
  // Used to check if Unity client version is too old and requires an update notification on startup
  minimumClientVersion: "2.10.3",
  // Same as above by acts as the default client version for standalone web & development configured apps
  placeholderClientVersion: "100.100.100",
  // Used only for identifying the current web app version, currently has no impact on user or app operation
  webVersion: "2.7.14",
  // Maintenance Mode used for blocking web app access during schedules maintainence tasks where the app must be fully blocked
  maintenanceModeEnabled: false,
  serviceOutageBlocker: false,
  platformConfigs: {
    [DeviceFamilies.Oculus]: {
      minimumClientVersion: "2.10.4",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
      applicationIdentifiers: {
        "com.beyourbest.vision": "4023081667710848",
        "com.beyourbest.visionxr": "5105468496138399"
      }
    },
    [DeviceFamilies.Windows]: {
      minimumClientVersion: "2.15.1",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
    },
    [DeviceFamilies.OSX]: {
      minimumClientVersion: "2.15.1",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
    },  
    [DeviceFamilies.Pico]: {
      minimumClientVersion: "2.6.5",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
      applicationIdentifiers: {
        "com.beyourbest.vision": "fc741fd0c4fa3592fe463d343bc13a7f"
      }
    },
    [DeviceFamilies.Unknown]: {
      minimumClientVersion: "2.10.3",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
    },
    [DeviceFamilies.Android]: {
      minimumClientVersion: "2.11.1",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
    },
    [DeviceFamilies.None]: {
      minimumClientVersion: "2.10.3",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
    },
    [DeviceFamilies.Web]: {
      minimumClientVersion: "2.10.3",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
    },
  },
  // Amplitude API Key
  amplitude_api_key: "bb92e7668d9b16dee8132523a3079c85",
  // Snapchat Pixel ID
  snapchat_pixel_id: "9dda1f4a-959b-4921-ab00-ad09184bf417",
  // Facebook Pixel ID
  facebook_pixel_id: "275101196855193"
};
